import { useMemo } from 'react';

import { useTheme } from '@mui/material';

import type { Activities } from '@graphql/__generated__/graphql';

export const useActivityStatusColor = ({
  activity,
}: {
  activity: Pick<Activities, 'activity_type' | 'done' | 'success'>;
}) => {
  const theme = useTheme();

  return useMemo(() => {
    if (
      activity.activity_type === 'note' ||
      activity.activity_type === 'email' ||
      activity.activity_type === 'create_user' ||
      activity.activity_type === 'agent_opt_in' ||
      activity.activity_type === 'agent_quiz_completed' ||
      activity.activity_type === 'lead_status_agent' ||
      activity.activity_type === 'module_granted' ||
      activity.activity_type === 'module_revoked' ||
      activity.activity_type === 'onboarding_status_changed' ||
      activity.activity_type === 'agent_profile_visibility_changed'
    ) {
      return theme.palette.primary.main;
    }
    if (!activity.done) {
      return theme.palette.warning.main;
    }
    return activity.success
      ? theme.palette.success.main
      : theme.palette.error.main;
  }, [activity, theme]);
};
